import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

const ItemsInOrderTableUnitPrice = ({ discount, extraCharge, unitPrice }) => {
  const [t] = useTranslation();
  const eaLabel = t('ITEM_EA_ABB');
  const commonClass =
    'exclude-global mb-1 text-xs text-univers u-color--DarkGray';

  const buildSection = (label, value) => (
    <div className="mt-3">
      <p className={commonClass}>{label}</p>
      <p className={commonClass}>{`${value} ${eaLabel}`}</p>
    </div>
  );

  return (
    <>
      <p className={commonClass}>{`${unitPrice} ${eaLabel}`}</p>
      {!!discount && buildSection(t('INVOICE_DISCOUNT_LABEL'), discount)}
      {!!extraCharge &&
        buildSection(t('INVOICE_EXTRA_CHARGE_LABEL'), extraCharge)}
    </>
  );
};

ItemsInOrderTableUnitPrice.propTypes = {
  extraCharge: PropTypes.string,
  discount: PropTypes.string,
  unitPrice: PropTypes.string.isRequired
};

export default ItemsInOrderTableUnitPrice;
